import { Dispatch, Middleware } from 'redux';
import Sentry, { isSentryEnabled } from '../services/sentry.service';
import { ApplicationState } from './reducers';
import { Actions, TypeKeys } from './actions';

const actionTransformer = (action: Actions) => {
  const { type } = action;

  switch (type) {
    case TypeKeys.APP_LOAD_SUCCESS:
      return {
        appId: action.app.id
      };
    case TypeKeys.FORM_INITIALIZE: {
      return {
        formId: action.form.id,
        recordId: action.record?.id,
        projectId: action.projectId,
        subformAttributeId: action.subformAttributeId,
        subformIdx: action.subformIdx
      };
    }
    case TypeKeys.FORM_UPDATE_RECORD_GEOMETRY: {
      return {
        geometryType: action.geometry?.type,
      };
    }
    case TypeKeys.FORM_HYDRATE: {
      return {
        formId: action.form.id,
        projectId: action.projectId,
      };
    }
    case TypeKeys.APP_INSTALL_SUCCESS: {
      return {
        appId: action.app.id
      };
    }
    case TypeKeys.FORM_ADD_RECORD_ASSOCIATE:
    case TypeKeys.FORM_UPDATE_RECORD_ASSOCIATE:
    case TypeKeys.FORM_ADD_RECORD_ASSOCIATED_TO:
      return {
        associationAttributeId: action.associationAttributeId,
        recordId: action.record?.id,
        surveyId: action.record?.surveyId,
        index: 'index' in action ? action.index : undefined
      };

    case TypeKeys.FORM_ADD_CHILD_RECORD:
    case TypeKeys.FORM_RESET:
      return {
        recordId: action.record?.id,
        surveyId: action.record?.surveyId
      };

    case TypeKeys.FORM_REMOVE_RECORD_ASSOCIATE:
    case TypeKeys.FORM_RESTORE_RECORD_ASSOCIATE:
      return {
        associationAttributeId: action.associationAttributeId,
        index: action.index,
        attributeCount: action.attributes?.length
      };

    case TypeKeys.FORM_UPDATE_RECORD_DATA:
      return {
        path: action.path,
        valueType: typeof action.value,
        isArray: Array.isArray(action.value)
      };

    case TypeKeys.AUTH_SUCCESS:
    case TypeKeys.AUTH_VERIFY_SUCCESS:
      return {
        userId: action.user?.userId
      };

    case TypeKeys.APP_LOAD_FAILURE:
    case TypeKeys.APP_INSTALL_FAILURE:
      return {
        errorMessage: action.err?.message
      };
    case TypeKeys.APP_SYNC_ERROR:
      return {
        errorMessage: action.error?.message
      };
    case TypeKeys.APP_SYNC_STATE_UPDATE: {
      return {
        id: action.id,
        syncState: action.syncState
      }
    }
  }
  return {};
};

export const sentryMiddleware: Middleware<{}, ApplicationState, Dispatch<Actions>> = () => {

  if (!isSentryEnabled()) {
    return next => (action: Actions) => next(action);
  }

  const filteredBreadcrumbActions: Set<string> = new Set([
    'persist/REHYDRATE',
    'persist/PERSIST',
    TypeKeys.AUTH_START,
    TypeKeys.APP_UPDATE_NETWORK
  ]);

  return next => (action: Actions) => {
    const { type } = action;
    if (!filteredBreadcrumbActions.has(type)) {
      const data = actionTransformer(action);
      Sentry.addBreadcrumb({
        category: 'redux.action',
        message: type,
        level: "info",
        data
      });
    }
    return next(action);
  };
};